// extracted by mini-css-extract-plugin
export default {"contentWrapper":"SearchFilters-module__contentWrapper___uckAj"};